// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"infractionCard_cardContainer__2rh8M","lightOrangeCard":"infractionCard_lightOrangeCard__1cW7F","darkOrangeCard":"infractionCard_darkOrangeCard__1POrK"};